import { useTranslation } from "react-i18next"
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material"
import Account from "../Pages/Account"

const AccountDialog = ({handleClose, open}: {handleClose: () => void, open: boolean}) => {
  const { t } = useTranslation()

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogContent sx={{paddingTop: 0}}>
        <Account onChange={handleClose} />
      </DialogContent>
      <DialogActions sx={{margin: "10px"}}>
        <Button variant="contained" onClick={handleClose} autoFocus>{t('Ok')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default AccountDialog
